<template>
  <el-dialog custom-class="medium-dialog" title="隐形批次号" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">

    <el-form :model="item" ref="form1" :rules="rules">
      <el-row :gutter="20" v-if="lens">
        <el-col :span="12">
          <el-form-item label="球镜" :label-width="formLabelWidth" prop="Y" >
            <el-select v-model="item.Y" placeholder="请选择"  :required="true" filterable>
              <el-option v-for="row in Yarr" :key="row" :label="row" :value="row"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20"  v-if="lens">
      <el-col :span="12">
        <el-form-item label="柱镜" :label-width="formLabelWidth" prop="X">
          <el-select v-model="item.X" placeholder="请选择" :required="true">
            <el-option v-for="row in Xarr" :key="row" :label="row" :value="row"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="批次号" :label-width="formLabelWidth" prop="batchno">
            <el-input v-model="item.batchno"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="有效期" :label-width="formLabelWidth" prop="endtime">
            <el-date-picker  v-model="item.endtime" :value-format="'yyyy-MM-dd'"
                            type="date"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="盘点数量" :label-width="formLabelWidth" prop="totalnumber">
            <el-input-number v-model="item.totalnumber" :min="1" :controls="false"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="注册证号" :label-width="formLabelWidth" prop="certno">
            <el-select v-model="item.certno" placeholder="请选择"  :required="true" @change="selCertNo">
              <el-option v-for="row in certs" :key="row.certno" :label="row.certno" :value="row.certno"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="厂家" :label-width="formLabelWidth">
           {{item.certorg}}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogFormVisible=false">取 消</el-button>
      <el-button type="primary" @click="saveData">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {getlistSimp} from '@/api/set/certmanage'

  export default {
    name: "AddYinXing",
    data() {
      return {
        certs: [],
        seedcode: '',
        tableData: [],
        Xarr: [],
        Yarr: [],
        formLabelWidth:"140px",
        item: {
          X:'',
          Y:'',
          packagesize: '',
          totalnumber: 1,
          P:0,
          batchno: "",
          certno: '',
          certorg: '',
          endtime: ""
        },
        dialogFormVisible: false,
        rules: {////////定义正则验证字段。
          X: [
            {required: true, message: '柱镜必填！', trigger: 'blur'},
          ],
          Y: [
            {required: true, message: '球镜必填！', trigger: 'blur'},
          ],
          batchno: [
            {required: true, message: '批次号必填！', trigger: 'blur'},
          ],
          endtime: [
            {required: true, message: '有效期必填！', trigger: 'blur'},
          ],
          certno: [
            {required: true, message: '注册证号必选', trigger: 'blur'},
          ],
          totalnumber: [
            {required: true, message: '盘点数量必填', trigger: 'blur'},
          ],
        },
      }
    },
    props: {
      lens: true
    },
    methods: {
      error(msg) {
        this.$message({
          message: msg,
          type: 'error'
        })
      },
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            this.item.batchno = this.item.batchno.trim();
            if (this.lens) {
              this.item.packagesize = '{"X":"' + this.item.X + '","Y":"' + this.item.Y + '"}';
            } else
              this.item.packagesize = '';

            for (let i in this.tableData) {
              var row = this.tableData[i];
              if (row.batchno == this.item.batchno && row.packagesize == this.item.packagesize) {
                this.error('批次号重复，请核对！');
                return;
              }
            }
            this.dialogFormVisible = false
            this.$message({
              message: '保存成功！',
              type: 'success'
            })
            var retRow = {}
            for (let key in this.item) {
              retRow[key] = this.item[key]
            }
            this.$emit("afterAddYX", retRow)
          }
        });
      },
      selCertNo() {
        for (let i in this.certs) {
          var certRow = this.certs[i];
          if (certRow.certno == this.item.certno) {
            this.item.certorg = certRow.certorg;
            break;
          }
        }
      },
      show(seedcode,costpricebook,tableData) {
        this.item.Y=''
        this.item.X=''
        this.item.packagesize=''
        this.item.totalnumber=1
        this.item.batchno=''
        this.item.certno=''
        this.item.certorg=''
        this.item.endtime=''
        this.seedcode = seedcode;
        this.Xarr=[]
        this.Yarr=[]

        if(this.lens) {
          this.item.X='0.00'
          if (costpricebook.XStart >= costpricebook.XEnd) {
            for (let i = costpricebook.XStart; i >= costpricebook.XEnd; i -= costpricebook.XSpace) {
              this.Xarr.push(i.toFixed(2))
            }
          } else {
            for (let i = costpricebook.XStart; i <= costpricebook.XEnd; i += costpricebook.XSpace) {
              this.Xarr.push(i.toFixed(2))
            }
          }

          if (costpricebook.YStart >= costpricebook.YEnd) {
            for (let i = costpricebook.YStart; i >= costpricebook.YEnd; i -= costpricebook.YSpace) {
              this.Yarr.push(i.toFixed(2))
            }
          } else {
            for (let i = costpricebook.YStart; i <= costpricebook.YEnd; i += costpricebook.YSpace) {
              this.Yarr.push(i.toFixed(2))
            }
          }
        }

        this.tableData=tableData;
        this.dialogFormVisible = true;
        this.getCertNo();
      },
      getCertNo() {//后台配置的证书：采购和盘点时使用
        this.certs =[]
        getlistSimp({
          certtype: '1',
          seedcode: this.seedcode,
        }).then(response => {
          this.certs = response.data.obj;
          if (this.certs.length == 1) {
            this.item.certno = this.certs[0].certno
            this.item.certorg = this.certs[0].certorg
          }
        }).catch((error) => {
          console.log(error)
        });
      }
    },
    mounted() {
    }
    ,
    components: {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/warehouse/AddYinXing.vue